import React from 'react'

import type { DialogIconComponent } from './constants'
import { useStyles } from './styles'

interface DialogContentProps {
  icon: DialogIconComponent
  iconColor: string
  description?: React.ReactNode
}

export const DialogContent: React.FC<DialogContentProps> = ({
  icon: Icon,
  iconColor,
  description
}) => {
  const { styles } = useStyles()

  return (
    <>
      <div className={styles.iconContainer}>
        <Icon color={iconColor} aria-hidden />
      </div>
      {description && <p className={styles.description}>{description}</p>}
    </>
  )
}
